"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateCodePhone = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
var constants_1 = require("../../../constants");
var phones_1 = require("../../../actions/phones");
var commonweb_utils_1 = require("commonweb-utils");
var ajax_util_1 = require("../../../utils/ajax/ajax.util");
var form_hooks_1 = require("../../../utils/forms/form-hooks");
var inputs_component_1 = require("../../../components/inputs.component");
var ErrorContentMapper_1 = require("../../../utils/errorcodes/ErrorContentMapper");
var commonUtils_1 = require("../../../common/utils/commonUtils");
var triggerOperationResult_1 = require("../../../utils/fpti/triggerOperationResult");
var utils_1 = require("../../../common/utils/phones/utils");
var phone_1 = require("../../../utils/container/phone");
var beaver_logger_1 = require("../../../utils/logging/beaver-logger");
var constants_2 = require("./constants");
var page = require("page");
exports.ValidateCodePhone = function (props) {
    var _a = React.useState(false), showSpinner = _a[0], setSpinner = _a[1];
    var _b = React.useState(false), screenSpinner = _b[0], setScreenSpinner = _b[1];
    var _c = React.useState(false), isDisabled = _c[0], setDisabled = _c[1];
    var _d = React.useState(false), isSubmitted = _d[0], setSubmitted = _d[1];
    var initializer = function () {
        return {
            form: {
                phoneConfirmationCodeInput: {
                    elementType: "input",
                    elementConfig: {
                        type: "text",
                        placeholder: props.content.phones.code.placeholder,
                        suggestionText: props.content.common.genericBlankFieldError,
                    },
                    value: "",
                    validation: {
                        required: true,
                    },
                    isValid: false,
                    isTouched: false,
                },
            },
            formIsValid: false,
            formMessage: "",
        };
    };
    var resendConfirmationCode = function () {
        /* Resend link will be disabled if validation process for current OTP is in progress */
        if (!showSpinner) {
            event.preventDefault();
            setFormMessage("");
            setScreenSpinner(true);
            setSubmitted(false);
            setValue("phoneConfirmationCodeInput", "value", "");
            var formData = {};
            formData["id"] = props.route.enter.params.id;
            ajax_util_1.default.post$(props.dispatch, props._csrf, "" + constants_1.default.ROUTES.API.PHONES.CONFIRM, formData, { component: { name: constants_1.default.VIEWS.PHONES.MANAGE } })
                .then(function () {
                setFormMessage("");
                setScreenSpinner(false);
                setSubmitted(false);
            })
                .catch(function (error) {
                setScreenSpinner(false);
                setSubmitted(false);
                var errorMessage = ErrorContentMapper_1.getPhoneErrorContent(error, props.content);
                setFormMessage(errorMessage);
                beaver_logger_1.default().info(constants_2.PHONE.RESEND_CONFIRMATION_CODE, {
                    message: errorMessage,
                });
                triggerOperationResult_1.triggerOperationResult(props.phoneFpti.resendConfirmationCode, constants_1.default.FPTI.FAILURE, errorMessage);
                return;
            });
        }
        else {
            event.preventDefault();
        }
    };
    var submitHandle = function () {
        var formData = {}, form = inputs.form;
        var phoneToBeConfirmed = commonUtils_1.findObjectInListById(props.phones, props.route.enter.params.id);
        formData["id"] = props.route.enter.params.id;
        formData["code"] = form.phoneConfirmationCodeInput.value;
        formData["channel"] = "web";
        formData["isTcpaEnabled"] = phone_1.isTcpaEnabled(phoneToBeConfirmed, props);
        formData["isSCAEnabled"] = utils_1.isSCAEnabled(props.features);
        setSubmitted(true);
        if (!inputs.formIsValid) {
            return;
        }
        var url = "" + constants_1.default.ROUTES.API.PHONES.VALIDATE_CONFIRM;
        setFormMessage("");
        setSpinner(true);
        setDisabled(true);
        ajax_util_1.default.post$(props.dispatch, props._csrf, url, formData, {
            component: { name: constants_1.default.VIEWS.PHONES.VALIDATE_CODE },
        })
            .then(function (phoneInfo) {
            props.dispatchPhoneConfirm(phoneInfo);
            var toastIntent = constants_1.default.VIEWS.PHONES.TOAST_INTENTS.CONFIRM;
            if (phoneInfo && phoneInfo.phones) {
                phoneInfo.phones = commonUtils_1.modifyObjectWithFactorById(phoneInfo.phones, props.route.enter.params.id, toastIntent, true);
            }
            props.performedAction(toastIntent);
            if (props.exitView == "add-phone" &&
                phoneInfo &&
                phoneInfo.ppcSynchronyDeeplinks &&
                Object.keys(phoneInfo.ppcSynchronyDeeplinks).length != 0) {
                var ppcUpdate = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PHONES.UPDATE_PPC;
                page.redirect(ppcUpdate);
            }
            else {
                page.redirect(constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PHONES.MANAGE);
            }
        })
            .catch(function (error) {
            setSpinner(false);
            setDisabled(false);
            var errorMessage = ErrorContentMapper_1.getPhoneErrorContent(error, props.content);
            beaver_logger_1.default().info(constants_2.PHONE.VALIDATE_CONFIRMATION_CODE, {
                message: errorMessage,
            });
            setFormMessage(errorMessage);
            triggerOperationResult_1.triggerOperationResult(props.phoneFpti.validateCode, constants_1.default.FPTI.FAILURE, errorMessage);
            return;
        });
    };
    var getForm = function () {
        var formElementsArray = [];
        var phoneContent = props.content.phones, phoneFpti = props.phoneFpti;
        for (var key in inputs.form) {
            formElementsArray.push({
                id: key,
                config: inputs.form[key],
            });
        }
        var form = (React.createElement("form", { onSubmit: submitHandler },
            inputs.formMessage ? (React.createElement(pp_react_1.Alert, { type: "error", className: "form-alert" }, inputs.formMessage)) : null,
            React.createElement("div", { className: "alignLeft" },
                React.createElement(pp_react_1.Text, { size: "xl3", className: "manage-address-header" }, phoneContent.confirm.title),
                React.createElement(pp_react_1.Text, { size: "sm", className: "manage-address-info manage-address-info-color" }, phoneContent.confirm.description)),
            formElementsArray.map(function (formElement) { return (React.createElement(inputs_component_1.default, { key: formElement.id, id: "test_validatePhoneCodeTextField", elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, value: formElement.config.value, isInvalid: !formElement.config.isValid, shouldValidate: formElement.config.validation, isTouched: formElement.config.isTouched, changed: function (event) {
                    return inputChangedHandler(event, formElement.id);
                }, isDisabled: isDisabled, IsSubmitted: isSubmitted })); }),
            React.createElement(pp_react_1.Button, { type: "submit", className: "addPhone-submit_button", id: "test_validatePhoneCodeButton", "data-name": phoneFpti.validateCode, disabled: showSpinner }, showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "loading-spinner", screenReaderText: "loading", inverse: true })) : (React.createElement(pp_react_1.Text, { size: "md", medium: true }, phoneContent.confirm.button))),
            React.createElement("div", { className: "phoneConfirmation-resend_code_link" },
                React.createElement(pp_react_1.Link, { href: "/", onClick: resendConfirmationCode, "data-name": phoneFpti.resendConfirmationCode }, props.content.phones.resend.link))));
        return (React.createElement("div", { className: "generic-container" }, screenSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "panelSpinnerNew", size: "lg" })) : (form)));
    };
    var _e = form_hooks_1.default(initializer(), submitHandle), inputs = _e.inputs, inputChangedHandler = _e.inputChangedHandler, submitHandler = _e.submitHandler, setFormMessage = _e.setFormMessage, setValue = _e.setValue;
    return getForm();
};
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account, fpti = _a.fpti, features = _a.features;
    var phones = commonweb_utils_1.objectUtils.safeGet(account, "phones.phones") || {}, phoneFpti = fpti.phones, exitView = route.exit && route.exit.view;
    phones = utils_1.changeNumberFormatForNonSCARegions(phones, utils_1.isSCAEnabled(features));
    return {
        _csrf: _csrf,
        ui: ui,
        content: content,
        route: route,
        phones: phones,
        phoneFpti: phoneFpti,
        exitView: exitView,
        features: features,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatchPhoneConfirm: function (phones) { return dispatch(phones_1.changePhone(phones)); },
        performedAction: function (typeOfAction) {
            return dispatch(phones_1.actionClicked(typeOfAction));
        },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.ValidateCodePhone);
